var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6V5.25C2.5 4.05653 2.97411 2.91193 3.81802 2.06802C4.66193 1.22411 5.80653 0.75 7 0.75C8.19347 0.75 9.33807 1.22411 10.182 2.06802C11.0259 2.91193 11.5 4.05653 11.5 5.25V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H2.5ZM12.25 7.5H1.75V15H12.25V7.5ZM6.25 11.799C5.96404 11.6339 5.74054 11.3791 5.61418 11.074C5.48782 10.7689 5.46565 10.4307 5.55111 10.1117C5.63657 9.79278 5.82489 9.51095 6.08686 9.30993C6.34882 9.10892 6.6698 8.99996 7 8.99996C7.3302 8.99996 7.65118 9.10892 7.91314 9.30993C8.17511 9.51095 8.36343 9.79278 8.44889 10.1117C8.53435 10.4307 8.51218 10.7689 8.38582 11.074C8.25946 11.3791 8.03596 11.6339 7.75 11.799V13.5H6.25V11.799ZM4 6H10V5.25C10 4.45435 9.68393 3.69129 9.12132 3.12868C8.55871 2.56607 7.79565 2.25 7 2.25C6.20435 2.25 5.44129 2.56607 4.87868 3.12868C4.31607 3.69129 4 4.45435 4 5.25V6Z",
    fill: "#99A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.a87df34d9bc69d3ec3b6d5831d790e4d.svg";
export { ForwardRef as ReactComponent };